module.exports = __webpack_public_path__ + "img/product_bg_01_en_01.85cc4bc.webp";